import React from 'react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Inline, xcss } from '@atlaskit/primitives';

import type { Nullable } from '../../types';
import { getBaseUrl } from '../../utils/get-base-url';
import SearchMetadataGeneric from '../search-metadata-generic';
import SearchMetadataLink from '../search-metadata-link';

const breadcrumbsContainerStyles = xcss({
	display: 'flex',
	alignItems: 'center',
	height: 'size.100',
	maxWidth: '246px', // Specified in the design
});

type ConfluenceResultMetaProps = {
	name: string;
	url?: string;
	webUiLink?: Nullable<string>;
};

export const ConfluenceResultMeta = ({
	url,
	name,
	webUiLink,
}: ConfluenceResultMetaProps): React.JSX.Element => {
	const baseUrl = url && getBaseUrl(url);
	const href = `${baseUrl}/wiki${webUiLink}`;

	return (
		<Inline xcss={breadcrumbsContainerStyles}>
			{href ? (
				<SearchMetadataLink label={name} href={`${baseUrl}/wiki${webUiLink}`} />
			) : (
				<SearchMetadataGeneric label={name} />
			)}
		</Inline>
	);
};
